import { $api } from '#/api/client'

interface IFetchCompanyNameResponse {
  companyName: string
  isLoading: boolean
  isError: boolean
}

export const useFetchCompanyName = (companyId: string): IFetchCompanyNameResponse => {
  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/companies/{companyId}',
    {
      params: {
        path: { companyId },
      },
    },
    {
      enabled: companyId.length > 0,
      select: (response): string => response.name,
    },
  )

  return {
    companyName: data ?? '',
    isLoading,
    isError,
  }
}
